/**
 * The form primitives the party dialogs share.
 *
 * Their own file so each dialog exports only its component — a module that
 * exports both a component and a helper breaks fast refresh, and the party
 * dialogs are exactly the screens somebody iterates on with the app running.
 */

import { useId } from 'react'

export function Field({
  label,
  value,
  onChange,
  required,
  type = 'text',
  autoFocus,
  placeholder,
}: {
  label: string
  value: string
  onChange: (v: string) => void
  required?: boolean
  type?: string
  autoFocus?: boolean
  placeholder?: string
}) {
  const id = useId()
  return (
    <div>
      <label htmlFor={id} className="mb-1 block text-[10px] uppercase tracking-[0.12em] text-stone-400">
        {label}
        {required && <span className="ml-0.5 text-amber-400">*</span>}
      </label>
      <input
        id={id}
        required={required}
        type={type}
        value={value}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-md border border-amber-400/10 bg-black/40 px-2.5 py-1.5 text-[12px] text-stone-200 outline-none placeholder:text-stone-600 focus:border-amber-400/30"
      />
    </div>
  )
}
